<template>
<div class="std-error-container">
 <div :id="errorMessageId" class="stdinput-error-message d-none">
        {{errorText}}<i class="bi bi-exclamation-circle"></i>
      </div>
      <div :id="okMessageId" class="stdinput-ok-message d-none">
        {{ okText }} <i class="bi bi-check-lg"></i>
      </div>
</div>
</template>

<script>
import intl from "./intl/intl";



export default {
  name: "stdInputErrorMessage",
  components: {

   
  },

  props: {
      
      errorMessageId: {
        type: String,
        default: null
      },
      okMessageId: {
        type: String,
        default: null
      },
      
      errorText: {
        type: String,
        default: ''
      },
      okText: {
        type: String,
        default: ''
      },
      showErrorMessageCallback: {
        type: Function,
        default: () => {console.log("ERROR MESSAGE CALLBACK")}
      }
     
        
  },
  mounted() {
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
    };
  },
  methods: {
     
  
    showErrorMessage(){
        this.showErrorMessageCallback();
        document.getElementById(this.errorMessageId).classList.remove("d-none");
        if (!document.getElementById(this.okMessageId).classList.contains("d-none")) {
            document.getElementById(this.okMessageId).classList.add("d-none");
        }
      },
      removeErrorMessage(){
    
        if (!document.getElementById(this.errorMessageId).classList.contains("d-none")) {
             document.getElementById(this.errorMessageId).classList.add("d-none");
        }
        
         
      },
      showOkMessage(){
        this.removeErrorMessage();
        document.getElementById(this.okMessageId).classList.remove("d-none");  
      },
               
    
  
    
  },
  watch: {
   

  },
  computed: {
    
    
    
    
    },
  
};
</script>
